import { Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import FilledButton from "../components/custom/FilledButton";
import { Helmet } from "react-helmet-async";

const ErrorScreen = () => {
  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>404 Error - Page Not Found | Glory Online Cyber Cafe</title>
        <meta
          name="description"
          content="The page you're looking for may have been moved or is temporarily unavailable. Return to the Glory Online Cyber Cafe homepage for more digital services and support."
        />
        <link rel="canonical" href="https://www.gloryservices.work/" />
      </Helmet>
      <Image
        src="../assets/errBG.png"
        alt="error"
        w="full"
        backgroundSize="100% 100%"
        pos={"absolute"}
      />
      <Flex
        direction="column"
        px={{ base: "5", md: "10", lg: "20" }}
        alignItems="center"
        justifyContent="center"
        gap="3"
        position="relative"
        zIndex={1}
        top="10"
        py={{ base: "20", md: "20" }}
      >
        <Image
          src="../assets/error.png"
          alt="error"
          h={{ base: "200px", md: "300px" }}
          objectFit="contain"
        />
        <Text
          fontSize={{ base: "md", md: "xl" }}
          textAlign="center"
          w={{ base: "xs", md: "xl" }}
        >
          The page you are looking for might have been removed, had its name
          changed or is temporarily unavailable.
        </Text>
        <FilledButton title="BACK TO HOMEPAGE" url="/" />
      </Flex>
    </>
  );
};

export default ErrorScreen;
